export {isShowAsLoggedIn, showAsLoggedOut, setLoginStatus, getLoginKennung};

function isShowAsLoggedIn() {
    try {
        return localStorage["kim.login.showAsLoggedIn"] === "true";
    } catch (error) {
        return false;
    }
}

function showAsLoggedOut() {
    try {
        localStorage["kim.login.showAsLoggedIn"] = false;
        document.cookie = "cclogin-data=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie = "club=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    } catch (error) {}
}

function setLoginStatus(status = false, kennung = '') {
    try {
        const aktuellerStatus = localStorage["kim.login.showAsLoggedIn"];
        const zielStatus = (status) ? "true" : "false";
        localStorage["kim.login.loginUsername"] = kennung;
        localStorage["kim.login.showAsLoggedIn"] = status;
        if(aktuellerStatus !== zielStatus) {
            localStorage["login.loggedInEvent"] = true;
        }
        const updateStatusEvent = new CustomEvent("login.status");
        window.dispatchEvent(updateStatusEvent);
    } catch (e) { }
}

function getLoginKennung() {
    try {
        return localStorage["kim.login.loginUsername"] || "";
    } catch(error) {
        return "";
    }
}

function checkLoginEventOnPageLoad() {
    try {
        const urlParams = new URLSearchParams(window.location.search);
        const loginChangeParam = urlParams.get('loginchange');
        
        if (loginChangeParam === 'login') {
            const loginChangeEvent = new CustomEvent("login.change", { 
                detail: { neuerStatus: 'eingeloggt' }
            });
            window.dispatchEvent(loginChangeEvent);

            const dlEvent = document.createElement('dl-event');
            dlEvent.setAttribute('name', 'login');
            dlEvent.setAttribute('method', 'email');
            document.body.appendChild(dlEvent);
            
            urlParams.delete('loginchange');
            const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '') + window.location.hash;
            if (window.history && window.history.replaceState) {
                window.history.replaceState({}, document.title, newUrl);
            }
        } else if (loginChangeParam === 'logout') {
            const loginChangeEvent = new CustomEvent("login.change", { 
                detail: { neuerStatus: 'ausgeloggt' }
            });
            window.dispatchEvent(loginChangeEvent);
            
            urlParams.delete('loginchange');
            const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '') + window.location.hash;
            if (window.history && window.history.replaceState) {
                window.history.replaceState({}, document.title, newUrl);
            }
        }
    } catch (error) {
    }
}

document.addEventListener('DOMContentLoaded', checkLoginEventOnPageLoad);
